import React from "react"

import styles from "./service-questions.module.css"

export default function ServiceQuestions({ children }) {
  return <div className={styles.serviceQuestions}>{children}</div>
}
